<template>
  <div class="Home">
    <navBar :dark-mode="true" />

    <section class="error404">
      <img src="../assets/404img.png" alt="">
      <div>
        <h3>Error<strong> 404</strong><span>.</span></h3>

        <p>
          No hemos logrado encontrar el contenido que buscas <br> <br>
          Utiliza el siguiente enlace para encontrar el <a href="/">camino de regreso.</a>
        </p>
      </div>

    </section>

    <contact />
    <Footer />
    <wApp />

  </div>
</template>
<script>

import { url } from '../global/index';
import navBar from '../components/fixed/navBar.vue'
import contact from '../components/contacto.vue'
import Footer from '../components/footer.vue';
import wApp from '../components/fixed/wapp.vue'

export default {
  name: 'error',
  components: {
    navBar,
    contact,
    wApp,
    Footer
  },

  data() {
    return {
      url,
    }
  },
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.tall {
  height: 50vw;
  background-color: rgba(255, 0, 0, 0.295);
}

.error404 {

  padding: 16.041666666666668VW 20.729166666666668VW 9.114583333333332VW 14.114583333333334VW;
  gap: 12.291666666666666VW;
  display: flex;
  flex-direction: row;
}

.error404 h3 {
  font-family: "Montserrat", sans-serif;
  color: #282828;
  font-size: var(--XXXL);
  font-weight: 300;

}

.error404 h3 strong {
  font-weight: 700;
}

.error404 h3 span {
  color: #F1C422;
  rotate: 45deg;

}

.error404 img {
  width: 29.6875VW;
  height: 20.78125VW;
}

.error404 div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2.1875VW;
}

.error404 p {
  color: var(--Black, #282828);
  font-family: "Hind", sans-serif;
  font-size: var(--S);
  font-style: normal;
  font-weight: 400;
  line-height: 1.1458333333333333VW;
  letter-spacing: 0.043750000000000004VW;
}

.error404 a {
  color: var(--Black, #282828);

}

:root {
  --color-letra: #ED87C0;
}

@media(max-width: 1440px) {
  .error404 img {
    width: 31.180555555555557VW;
    height: 21.805555555555557VW;
  }

  .error404 {
    padding: 16.805555555555557VW 12.097222222222221VW 10.277777777777777VW 13.750000000000002VW;
    gap: 10.069444444444445VW;
  }
}

@media(max-width: 834px) {
  .error404 {
    flex-direction: column;
    align-items: center;
    padding: 22.18225419664269VW 20.983213429256594VW 9.952038369304557VW;
  }

  .error404>div {
    align-items: center;
  }

  .error404 p {
    text-align: center;
    line-height: 2.6378896882494005VW;
    letter-spacing: 0.10071942446043165VW;
  }

  .error404 img {
    width: 41.60671462829736VW;
    height: 29.136690647482016VW;
  }
}

@media(max-width: 505px) {
  .error404 img {
    width: 40.82125603864734VW;
    height: 28.743961352657006VW;
  }

  .error404 {
    padding: 55.09661835748793VW 13.6231884057971016VW 14.492753623188406VW;
    gap: 16vw;
  }

  .error404 h3 {
    font-size: var(--XXL);
  }

  .error404 p {
    line-height: 5.314009661835748VW;
    letter-spacing: 0.2028985507246377VW;
  }
}
</style>
